import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-data-filter-multi-string-input',
  templateUrl: './data-filter-multi-string-input.component.html',
  styleUrls: ['./data-filter-multi-string-input.component.scss']
})
export class DataFilterMultiStringInputComponent implements OnInit, OnChanges {

  public displayModel: string;
  public displayModelChange = new Subject<string>();
  private SPACE_SEPARATOR = ' ';
  private _separators = [',', this.SPACE_SEPARATOR];

  @Input() public labelKey: string;
  @Input() public placeholderKey: string;
  @Input() public disabled     = false;
  @Input() public model: Array<string>;
  @Output() public modelChange: EventEmitter<any> = new EventEmitter<any>();

  @Input() set separators(value: string[]) {
    this._separators = [...value, this.SPACE_SEPARATOR];
  }

  public ngOnInit(): void {
    this.displayModelChange.pipe(
      distinctUntilChanged()
    ).subscribe(newDisplayModel => {
      this.displayModel = newDisplayModel;
      this.modelChange.emit(this.splitInput(newDisplayModel, this._separators))
    })
  }

  public ngOnChanges(changes: SimpleChanges) {
    // if displayModel already match model, no need to update it
    if (changes.hasOwnProperty('model')
      && this.areArrayDifferent(changes.model.currentValue, this.splitInput(this.displayModel, this._separators))) {
      this.displayModel = changes.model.currentValue.join(this.SPACE_SEPARATOR);
    }
  }

  private splitInput(input: string, separators: Array<string>): string[] {
    if (input == null || input.length === 0) {
      return [];
    } else if (separators.length === 0) {
      return [input];
    }

    const result                      = [];
    const [currentSeparator, ...rest] = separators;
    if (input.includes(currentSeparator)) {
      result.push(...input.split(currentSeparator)
        .filter(string => string.length > 0)
        .map(t => this.splitInput(t, rest))
        .flat())
    } else {
      result.push(...this.splitInput(input, rest));
    }
    return result;
  }

  private areArrayDifferent(arrayA: Array<string> = [], arrayB: Array<string> = []): boolean {
    const arrayADiff = arrayA.filter(item => !arrayB.includes(item)).length > 0;
    const arrayBDiff = arrayB.filter(item => !arrayA.includes(item)).length > 0;

    return arrayADiff || arrayBDiff;
  }

  public onNgChange(newValue: string) {
    this.displayModelChange.next(newValue);
    // explicitly changing the value because pasting in the input do not always change the value of the model
    this.displayModel = newValue;
  }

}
